module.exports = __webpack_public_path__ + "static/media/external.8b370ed8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Exchange/scenes/Failed/img/external.svg
// module id = 143
// module chunks = 0